const stats = [
  { value: '10M+', label: 'Leads Generated' },
  { value: '95%', label: 'Data Accuracy' },
  { value: '500+', label: 'Enterprise Clients' },
  { value: '50+', label: 'CRM Integrations' },
];

export const StatsSection = () => {
  return (
    <section className="py-24 px-4">
      <div className="container mx-auto max-w-6xl">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="landing-glass rounded-2xl p-6 text-center"
            >
              <div className="text-3xl md:text-4xl font-bold mb-2 landing-gradient-text-accent">
                {stat.value}
              </div>
              <div className="text-sm landing-text-muted">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
